import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../lib/api";
import toast from "react-hot-toast";

export const useCategories = () => {
    return useQuery({
        queryKey: ["admin-categories"],
        queryFn: async () => {
            const { data } = await api.get("/company/categories");
            return data.success ? data.data : [];
        },
    });
};

export const useAllCategories = () => {
    return useQuery({
        queryKey: ["admin-categories-all"],
        queryFn: async () => {
            const { data } = await api.get("/company/categories/all");
            return data.success ? data.data : [];
        },
    });
};

export const useCreateCategory = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.post("/company/categories", payload),
        onSuccess: () => {
            toast.success("Category created successfully!");
            qc.invalidateQueries(["admin-categories"]);
            qc.invalidateQueries(["admin-categories-all"]);
        },
        onError: (err) => toast.error(err.response?.data?.message || "Failed to create"),
    });
};

export const useUpdateCategory = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, payload }) => api.put(`/company/categories/${id}`, payload),
        onSuccess: () => {
            toast.success("Category updated!");
            qc.invalidateQueries(["admin-categories"]);
            qc.invalidateQueries(["admin-categories-all"]);
        },
        onError: (err) => toast.error(err.response?.data?.message || "Update failed"),
    });
};

export const useDeleteCategory = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => api.delete(`/company/categories/${id}`),
        onSuccess: () => {
            toast.success("Category deleted");
            qc.invalidateQueries(["admin-categories"]);
            qc.invalidateQueries(["admin-categories-all"]);
        },
        onError: () => toast.error("Cannot delete category with subcategories"),
    });
};